import React from "react";
import { Box, Typography } from "@mui/material";
import Calendar from "../../Calendar"; // Relative import from same components folder

/**
 * CalendarTab Component
 *
 * Renders the calendar tab in the Work Order Details view.
 * Passes the required props to the Calendar component.
 *
 * @param {string|number} workOrderId - ID of the current work order
 * @param {string|number} currentUserId - ID of the currently logged-in user
 * @param {Array} events - Array of calendar event objects
 * @param {Array} users - Array of user objects (to assign events to users)
 * @param {Function} setEvents - Setter function to update events from the calendar
 */
const CalendarTab = ({ workOrderId, currentUserId, events, users, setEvents }) => {
  return (
    <Box>
     

      {/* ✅ Calendar component handles its own logic and UI */}
      <Calendar
        defaultView="month"
        workOrderId={workOrderId}
        currentUserId={currentUserId}
        events={events}
        users={users}
        setEvents={setEvents}
      />
    </Box>
  );
};

export default CalendarTab;
